import React from "react";
import Event from "@mui/icons-material/Event";
import Schedule from "@mui/icons-material/Schedule";
import { getSessionTimeValue } from "repoV2/features/CheckoutPages/utils/getSessionDetailOptionsList";
import { ISingleSessionProps } from "./SingleSession.interfaces";
import styles from "./SingleSession.module.scss";
import { useSetSelectedSingleSessionDetails } from "./SingleSession.utils";

const SingleSession = ({ sessions }: ISingleSessionProps) => {
    const [session] = sessions;
    useSetSelectedSingleSessionDetails({ session });
    return (
        <div className={styles.Wrapper}>
            {session.startDate && (
                <div className={styles.DateWrapper}>
                    <Event className={styles.EventIcon} />
                    <div className={styles.Date}>{session.startDate}</div>
                </div>
            )}
            {session.startTime && session.endTime && (
                <div className={styles.TimeWrapper}>
                    <Schedule className={styles.ScheduleIcon} />
                    <div className={styles.Time}>{`${getSessionTimeValue(
                        session.startTime
                    )} - ${getSessionTimeValue(session.endTime)}`}</div>
                </div>
            )}
        </div>
    );
};

export default SingleSession;
